import { CarriersController } from "../../controllers/carriers-controller";
import { Carrier } from "../../models/carrier"
import { CarrierFilter } from "../../models/carrier-filter"
import { BusyService } from "../../services/busy-service";
import { WebApiService } from "../../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

import { autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import { DialogService } from "aurelia-dialog";
import { PageMessageService } from "../../services/page-message-service";
import { SimpleDialog } from "./../dialogs/simple-dialog";
import { SecurityService } from "../../services/security-service"; 6
import { TaskActionService } from "./../requests/TaskActionService";
import { UiActionButton } from "./../requests/UiActionButton";
import { CmpTaskDto } from "../../data/typegen/dtos/cmp-task-dto";
import { CmpTaskCommentDto } from "../../data/typegen/dtos/cmp-task-comment-dto";
import { DisplayValuePair } from "../../data/typegen/dtos/display-value-pair";
import { TaskState } from "../../data/enums/taskState";
import { RequestDto } from "../../data/typegen/dtos/request-dto";
import { DoUiActionDto } from "../../data/typegen/dtos/do-ui-action-dto";
import { CmpTaskBaseDto } from "../../data/typegen/dtos/cmp-task-base-dto";
import { RequestTypeIds } from "../../data/typegen/enums/request-type-ids";
import { RequestStateIds } from "../../data/typegen/enums/request-state-ids";
import { RequestDetailsScreenDataDto } from "../../data/typegen/dtos/request-details-screen-data-dto";
import { AppMessageService } from "../../services/app-message-service";
import { Router } from 'aurelia-router';
import { ActivityStreamItemBase } from "../../data/typegen/dtos/activity-stream-item-base";
import { IFulfillmentWidget } from "./new-user-request/new-user-request-fulfillment";

@singleton()
@autoinject()
export class RequestDetails {

    public requestedForUsers: Array<DisplayValuePair<string>> = [];
    public task: CmpTaskDto;
    public request: RequestDto;
    public tasks: Array<CmpTaskDto> = [];
    public activityStream: Array<ActivityStreamItemBase> = [];
    public taskState = TaskState;
    public requestTypeIds = RequestTypeIds;
    public requestStateIds = RequestStateIds;
    public taskDetailsComponent: IFulfillmentWidget;

    private cancelUiAction: UiActionButton;
    private originalRequest: RequestDto;
    private saveUiAction: UiActionButton;
    public carrier: Carrier;

    constructor(
        private taskActionService: TaskActionService,
        private securityService: SecurityService,
        private busyService: BusyService,
        private appMsg: AppMessageService,
        private msg: PageMessageService,
        private router: Router,
        private dialogService: DialogService,
        private api: WebApiService) {
    }

    public canModifyState: boolean;

    async activate(params) {
        var contractsAndInsuranceLeadsGroupId = "a86a7675-52ab-401e-b8a2-aaca50c7ffdc";
        const isContractsAndInsuranceLeadsMember = this.securityService.hasGroup(contractsAndInsuranceLeadsGroupId);
        this.canModifyState = this.securityService.hasRole("admin") || isContractsAndInsuranceLeadsMember;
        this.taskActionService.actionButtons.length = 0;
        this.carrier = null;
        await this.loadDataAsync(params.id);
    }


    public attached() {

        setTimeout(() => { this.fixVerticalTabindex('.page-content'); }, 100);

    }

    fixVerticalTabindex(selector) {
        var tabindex = 1;
        jQuery(selector).each(function (i, tbl) {
            jQuery(tbl).find('.row>div[class*="col"]:last-child').each(function (j, col) {
                jQuery(col).find('input,select,textarea').each(function (j, obj) {
                    jQuery(obj).attr('tabindex',tabindex++);
                });
            });
        });
    }

    async refresh() {
        await this.loadDataAsync(this.request.requestId);
    }

    public async doAction(uiAction: UiActionButton, validate = true) {
        this.msg.clear();
        this.appMsg.clearPageScopedMessages();

        if (uiAction.triggersSubmit) {
            await this.runValidationRules();

            var action = new DoUiActionDto<CmpTaskBaseDto>();
            action.taskDto = this.request;
            action.uiActionVerb = uiAction.key;

            // cancel request
            if (action.uiActionVerb == this.cancelUiAction.key) {
                action.actionReason = prompt("Enter a reason for the cancellation:");
                if (!action.actionReason) {
                    return
                }
            }

            if (uiAction.triggersSubmit) {
                var isValid = !validate || !uiAction.performValidation || await this.runValidationRules();
                if (isValid) {
                    await this.submitUiAction(action, uiAction.redirectAfterSubmit);
                }
            }
        }
    }

    private async runValidationRules() {
        // run standard rules before save
        // these rules should not require validation
        return true;
    }

    submitUiAction(action: DoUiActionDto<CmpTaskBaseDto>, redirectAfterSubmit: boolean = true) {
        //this.controller.validate();
        this.busyService.on();
        return this.api.post("Tasks", "DoRequestUiAction", action)
            .then(async (result) => {

                if (redirectAfterSubmit) {
                    var redirectRoute = AureliaCookie.get('nav_stack');
                    if (redirectRoute) {
                        this.router.navigateToRoute(redirectRoute);
                        AureliaCookie.delete('nav_stack');
                        return;
                    }
                }

                await this.loadDataAsync(this.request.requestId);
                this.updateUiActions();
                this.taskDetailsComponent.initUi();

                //var updatedTask = JSON.parse(result.response);
                //this.request = updatedTask;
                //this.originalTask = JSON.parse(JSON.stringify(this.request));
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    public async post() {
        await this.doAction(this.saveUiAction.children[0], false);
        await this.loadDataAsync(this.request.requestId);
    }

    async loadDataAsync(requestId) {
        this.busyService.on();
        return this.api.get("Tasks", "GetRequestDetailsScreenDataDto", { requestId: requestId })
            .then(async (result) => {
                const screenData = JSON.parse(result.response) as RequestDetailsScreenDataDto;
                this.request = screenData.request;
                this.tasks = screenData.tasks;
                this.originalRequest = JSON.parse(JSON.stringify(this.request)) as RequestDto;
                this.activityStream = screenData.activityStream;
                this.requestedForUsers = screenData.requestedForUsers;

                // carrier is needed for the requirements grid
                if( this.request.variables.CarrierId){
                    var carrierResult = await this.api.get("Carriers", "GetCarrierById", { carrierId: this.request.variables.CarrierId });
                    this.carrier = result && JSON.parse(carrierResult.response);
                }

                this.saveUiAction = this.taskActionService.addUiActionFromTemplate(TaskActionService.saveActionTemplate);
                this.cancelUiAction = this.taskActionService.addUiAction({
                    key: "sysverb_cancel",
                    name: "Cancel Request",
                    visible: this.request.active,
                    redirectAfterSubmit: true
                });

                setTimeout(() => {
                    this.updateUiActions();
                }, 100);

            })
            .finally(() => {
                this.busyService.off();
            });
    }


    private updateUiActions() {
        this.cancelUiAction.visible = this.request.active;
    }
}
